import { memo } from 'react';

import {
  PublicCustomFieldsProvider,
  type PublicCustomFieldsProviderProps,
} from '~/providers/PublicCustomFieldsProvider';

export const ContentCollectionCustomFieldsProvider = memo(
  (props: Omit<PublicCustomFieldsProviderProps, 'canViewCustomFields'>) => {
    return <PublicCustomFieldsProvider canViewCustomFields={true} {...props} />;
  },
);

ContentCollectionCustomFieldsProvider.displayName = 'ContentCollectionCustomFieldsProvider';
